import type {
    BrandIconComponent
} from "./type";
import {
    GOOGLE_COLOR_VIEW_BOX,
    MICROSOFT_SQUARE_SIZE,
    MICROSOFT_BRAND_COLOR,
    GOOGLE_COLOR_SHAPES,
    MICROSOFT_VIEW_BOX,
    MICROSOFT_SQUARES,
    BRAND_ICON_DATA
} from "./constant";
import {
    createMonoBrandIcon,
    createBrandIcon
} from "./util";
import {
    Path,
    Rect,
    G
} from "react-native-svg";

export const GoogleBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.google);

export const AppleBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.apple);

export const GitHubBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.gitHub);

export const GitLabBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.gitLab);

export const BitbucketBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.bitbucket);

export const XBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.x);

export const FacebookBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.facebook);

export const InstagramBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.instagram);

export const YouTubeBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.youTube);

export const TikTokBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.tikTok);

export const WhatsAppBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.whatsApp);

export const TelegramBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.telegram);

export const DiscordBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.discord);

export const RedditBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.reddit);

export const PinterestBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.pinterest);

export const SnapchatBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.snapchat);

export const ThreadsBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.threads);

export const MastodonBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.mastodon);

export const BlueskyBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.bluesky);

export const TwitchBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.twitch);

export const MessengerBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.messenger);

export const SignalBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.signal);

export const FigmaBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.figma);

export const NotionBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.notion);

export const TrelloBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.trello);

export const JiraBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.jira);

export const ConfluenceBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.confluence);

export const AsanaBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.asana);

export const LinearBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.linear);

export const VercelBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.vercel);

export const NetlifyBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.netlify);

export const ZoomBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.zoom);

export const GoogleMeetBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.googleMeet);

export const GmailBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.gmail);

export const GoogleDriveBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.googleDrive);

export const GoogleCalendarBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.googleCalendar);

export const DropboxBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.dropbox);

export const StripeBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.stripe);

export const PayPalBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.payPal);

export const ApplePayBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.applePay);

export const GooglePayBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.googlePay);

export const VisaBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.visa);

export const MasterCardBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.masterCard);

export const AmericanExpressBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.americanExpress);

export const AndroidBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.android);

export const AppStoreBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.appStore);

export const GooglePlayBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.googlePlay);

export const SpotifyBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.spotify);

export const NetflixBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.netflix);

export const SteamBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.steam);

export const PlayStationBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.playStation);

export const AirbnbBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.airbnb);

export const UberBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.uber);

export const ShopifyBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.shopify);

export const WordPressBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.wordPress);

export const MediumBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.medium);

export const SubstackBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.substack);

export const NpmBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.npm);

export const ReactBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.react);

export const TypeScriptBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.typeScript);

export const JavaScriptBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.javaScript);

export const DockerBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.docker);

export const FirebaseBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.firebase);

export const SupabaseBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.supabase);

export const AnthropicBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.anthropic);

export const ClaudeBrandIcon = createMonoBrandIcon(BRAND_ICON_DATA.claude);

export const GoogleColorBrandIcon = createBrandIcon({
    renderShape: () => <G>
        {
            GOOGLE_COLOR_SHAPES.map((shape) => <Path
                fill={shape.color}
                key={shape.color}
                d={shape.path}
            />)
        }
    </G>,
    brandTitle: BRAND_ICON_DATA.google.title,
    brandColor: BRAND_ICON_DATA.google.hex,
    viewBox: GOOGLE_COLOR_VIEW_BOX,
    name: "GoogleColor",
    isMultiColor: true
});

export const MicrosoftBrandIcon = createBrandIcon({
    renderShape: (color) => <G>
        {
            MICROSOFT_SQUARES.map((square) => <Rect
                height={MICROSOFT_SQUARE_SIZE}
                width={MICROSOFT_SQUARE_SIZE}
                key={square.color}
                x={square.x}
                y={square.y}
                fill={color}
            />)
        }
    </G>,
    brandColor: MICROSOFT_BRAND_COLOR,
    viewBox: MICROSOFT_VIEW_BOX,
    brandTitle: "Microsoft",
    name: "Microsoft"
});

export const MicrosoftColorBrandIcon = createBrandIcon({
    renderShape: () => <G>
        {
            MICROSOFT_SQUARES.map((square) => <Rect
                height={MICROSOFT_SQUARE_SIZE}
                width={MICROSOFT_SQUARE_SIZE}
                fill={square.color}
                key={square.color}
                x={square.x}
                y={square.y}
            />)
        }
    </G>,
    brandColor: MICROSOFT_BRAND_COLOR,
    viewBox: MICROSOFT_VIEW_BOX,
    brandTitle: "Microsoft",
    name: "MicrosoftColor",
    isMultiColor: true
});

export const BRAND_ICONS: Array<BrandIconComponent> = [
    GoogleBrandIcon,
    GoogleColorBrandIcon,
    AppleBrandIcon,
    MicrosoftBrandIcon,
    MicrosoftColorBrandIcon,
    GitHubBrandIcon,
    GitLabBrandIcon,
    BitbucketBrandIcon,
    XBrandIcon,
    FacebookBrandIcon,
    InstagramBrandIcon,
    YouTubeBrandIcon,
    TikTokBrandIcon,
    WhatsAppBrandIcon,
    TelegramBrandIcon,
    DiscordBrandIcon,
    RedditBrandIcon,
    PinterestBrandIcon,
    SnapchatBrandIcon,
    ThreadsBrandIcon,
    MastodonBrandIcon,
    BlueskyBrandIcon,
    TwitchBrandIcon,
    MessengerBrandIcon,
    SignalBrandIcon,
    FigmaBrandIcon,
    NotionBrandIcon,
    TrelloBrandIcon,
    JiraBrandIcon,
    ConfluenceBrandIcon,
    AsanaBrandIcon,
    LinearBrandIcon,
    VercelBrandIcon,
    NetlifyBrandIcon,
    ZoomBrandIcon,
    GoogleMeetBrandIcon,
    GmailBrandIcon,
    GoogleDriveBrandIcon,
    GoogleCalendarBrandIcon,
    DropboxBrandIcon,
    StripeBrandIcon,
    PayPalBrandIcon,
    ApplePayBrandIcon,
    GooglePayBrandIcon,
    VisaBrandIcon,
    MasterCardBrandIcon,
    AmericanExpressBrandIcon,
    AndroidBrandIcon,
    AppStoreBrandIcon,
    GooglePlayBrandIcon,
    SpotifyBrandIcon,
    NetflixBrandIcon,
    SteamBrandIcon,
    PlayStationBrandIcon,
    AirbnbBrandIcon,
    UberBrandIcon,
    ShopifyBrandIcon,
    WordPressBrandIcon,
    MediumBrandIcon,
    SubstackBrandIcon,
    NpmBrandIcon,
    ReactBrandIcon,
    TypeScriptBrandIcon,
    JavaScriptBrandIcon,
    DockerBrandIcon,
    FirebaseBrandIcon,
    SupabaseBrandIcon,
    AnthropicBrandIcon,
    ClaudeBrandIcon
];
